import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import { IBaseDispositionConfirmationFormProps } from "../Components/ConfirmationModal/ConfirmationForm";
import NotReachedConfirmationForm, {
  INotReachedConfirmationFormProps
} from "../Components/ConfirmationModal/NotReachedConfirmationForm";

const SessionContextNotReachedConfirmationForm: React.FC<IBaseDispositionConfirmationFormProps> =
  SessionContextValueProvider<
    Pick<
      INotReachedConfirmationFormProps,
      "disqualificationReasons" | "isNonCandidacyOverridden" | "setIsNonCandidacyOverridden"
    >,
    INotReachedConfirmationFormProps
  >({
    Component: NotReachedConfirmationForm,
    map: ({ leadDisqualifiers, setIgnoreNonCan, ignoreNonCan }) => ({
      disqualificationReasons: leadDisqualifiers,
      isNonCandidacyOverridden: ignoreNonCan,
      setIsNonCandidacyOverridden: setIgnoreNonCan
    })
  });

export default SessionContextNotReachedConfirmationForm;
